<template>
  <div class="nav-indicator">
    <span v-for="(item, index) in navIndicator" :key="index">
      <!-- Wrap both the icon and text in the <a> tag if item.link exists -->
      <a v-if="item.link" :href="item.link" class="nav-link">
        <img
          v-if="item.icon"
          :src="homeIcon"
          alt="Home Icon"
          class="nav-icon"
        />
        {{ item.text }}
      </a>
      <!-- Render as a span if there's no link -->
      <span v-else>{{ item.text }}</span>
      <span v-if="index < navIndicator.length - 1"> > </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'NavIndicator',
  props: {
    navIndicator: Array,
  },
  data() {
    return {
      homeIcon: require('@/assets/img/nav-home-icon.png'),
    };
  },
};
</script>

<style scoped>
.nav-indicator {
  font-size: 14px;
  color: #666;
  max-width: 1230px;
  /* margin-left: auto;
  margin-right: auto; */
  text-align: left;
}

.nav-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 5px;
  margin-bottom: 5px;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  color: #666;
  text-decoration: none;
}

.nav-link:hover {
  text-decoration: underline;
}

.nav-indicator span {
  margin-right: 1px;
}

.nav-indicator a,
.nav-indicator span {
  cursor: pointer;
  color: #666;
  text-decoration: none;
}
</style>